import { ABBREVIATED_MONTH_LIST, MONTH_QUARTER_STATUS } from '@constants/commonConstants';

export const toTitleCase = str => {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

export const formatNumberWithKAndM = number => {
  if (typeof number !== 'number') {
    return '0 K';
  }

  if (number < 0) {
    return '0 K';
  }
  let formatted;
  if (number >= 1000000000) {
    if (number % 1000000000 === 0) formatted = `${number / 1000000000} B`;
    else formatted = `${(number / 1000000000).toFixed(1)} B`;
  } else if (number >= 1000000) {
    if (number % 1000000 === 0) formatted = `${number / 1000000} M`;
    else formatted = `${(number / 1000000).toFixed(1)} M`;
  } else if (number >= 1000) {
    if (number % 1000 === 0) formatted = `${number / 1000} K`;
    else formatted = `${(number / 1000).toFixed(1)} K`;
  } else {
    formatted = number.toString();
  }
  if (number < 0) {
    return `-${formatted}`;
  } else if (formatted === '0') {
    return '0 K';
  } else return formatted;
};

export const GcspformatNumberWithKAndM = number => {
  if (typeof number !== 'number') {
    return '0 K';
  }
  let formatted;
  if (Math.abs(number) >= 1000000000) {
    if (number % 1000000000 === 0) formatted = `${number / 1000000000} B`;
    else formatted = `${(number / 1000000000).toFixed(1)} B`;
  } else if (Math.abs(number) >= 1000000) {
    if (number % 1000000 === 0) formatted = `${number / 1000000} M`;
    else formatted = `${(number / 1000000).toFixed(1)} M`;
  } else if (Math.abs(number) >= 1000) {
    if (number % 1000 === 0) formatted = `${number / 1000} K`;
    else formatted = `${(number / 1000).toFixed(1)} K`;
  } else {
    formatted = number.toString();
  }
  if (number) {
    return formatted;
  } else return '0 K';
};

export const uppercaseFirstLetter = str => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getTodaysDate = systemDateTime => {
  const currentDate = new Date(systemDateTime);
  const year = currentDate.getFullYear();
  const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  const day = currentDate.getDate().toString().padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};

export const getCurrentYear = systemDateTime => {
  const currentDate = new Date(systemDateTime);
  return currentDate.getFullYear();
};

export const getTomorrowDate = inputDateStr => {
  var currentDate = new Date(inputDateStr);
  currentDate.setDate(currentDate.getDate() + 1);
  var year = currentDate.getFullYear();
  var month = String(currentDate.getMonth() + 1).padStart(2, '0');
  var day = String(currentDate.getDate()).padStart(2, '0');

  var tomorrowDate = `${year}-${month}-${day}`;
  return tomorrowDate;
};

export const getConvertedPercentageInPx = (PercentageToBeDrawn, total, barPxLength, targetCase) => {
  if (targetCase !== null) {
    const percentage =
      barPxLength -
      (parseFloat(targetCase.soldPercentage) + parseFloat(targetCase.commitPercentage));
    return percentage.toFixed(2);
  } else {
    if (total === 0) {
      return '0';
    }
    const percentage = (PercentageToBeDrawn / total) * 100;
    const convertedPercentageToPx = (percentage / 100) * barPxLength;
    if (isNaN(convertedPercentageToPx)) return '0';
    else return convertedPercentageToPx.toFixed(2);
  }
};

export const getAccuracy = (sold, commit, forecastStatus = '') => {
  if (forecastStatus === MONTH_QUARTER_STATUS.SUBMITTED) {
    if (sold !== 0 && commit !== 0) {
      const accuracyPercentage = (sold / commit) * 100;
      if (accuracyPercentage > 999) return 999;
      else {
        return processNumber(accuracyPercentage);
      }
    } else if (sold === 0 && commit !== 0) {
      return 0;
    } else if (sold !== 0 && commit === 0) {
      return 0;
    } else if (sold === 0 && commit === 0) {
      return 100;
    }
  } else if (forecastStatus === MONTH_QUARTER_STATUS.MISSED) {
    if (sold !== 0) {
      return 0;
    } else if (sold === 0) {
      return 0;
    }
  }
};

export const formatDate = inputDate => {
  if (inputDate) {
    const originalDate = inputDate;
    const [day, month, year] = originalDate.split('/');

    // Months array for mapping numeric month to short month name
    const months = ABBREVIATED_MONTH_LIST;
    return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]} ${year}`;
  }
};

export const formatAWDDate = inputDate => {
  if (inputDate) {
    const originalDate = inputDate;
    const [year, month, day] = originalDate.split('-');

    // Months array for mapping numeric month to short month name
    const months = ABBREVIATED_MONTH_LIST;
    return `${parseInt(day, 10)} ${months[parseInt(month, 10) - 1]} ${year}`;
  }
};

export const dateFormat = inputDate => {
  // 2024-03-18T22:30:00.000Z to 26 Feb 2024

  const dateWithoutTimestamp = inputDate.split('T')[0];
  const [year, month, day] = dateWithoutTimestamp.split('-');
  const months = ABBREVIATED_MONTH_LIST;
  const date = new Date(year, month - 1, day);
  const dayOfMonth = date.getDate();
  const abbreviatedMonth = months[date.getMonth()];
  const fullYear = date.getFullYear();
  return `${dayOfMonth} ${abbreviatedMonth} ${fullYear}`;
};

export const dateFormatMonth = inputDate => {
  // 2024-03-18T22:30:00.000Z to Feb 26
  if (!inputDate) {
    return 'NA';
  }
  const dateWithoutTimestamp = inputDate.split('T')[0];
  const [year, month, day] = dateWithoutTimestamp.split('-');
  const months = ABBREVIATED_MONTH_LIST;
  const date = new Date(year, month - 1, day);
  const dayOfMonth = date.getDate();
  const abbreviatedMonth = months[date.getMonth()];

  return `${abbreviatedMonth} ${dayOfMonth}`;
};

export const dateFormatWithoutYear = inputDate => {
  // 2024-03-18T22:30:00.000Z to 26 Feb

  const months = ABBREVIATED_MONTH_LIST;
  const date = new Date(inputDate);
  const dayOfMonth = date.getDate();
  const abbreviatedMonth = months[date.getMonth()];
  return `${dayOfMonth} ${abbreviatedMonth}`;
};

export const QuarterNumber = quarter => {
  const numericPart = parseInt(quarter.substring(1));

  if (!isNaN(numericPart)) {
    return numericPart;
  }
  return 0;
};

export const structureMonth = abbreviatedMonth => {
  const monthMappings = {
    Jan: 'January',
    Feb: 'February',
    Mar: 'March',
    Apr: 'April',
    May: 'May',
    Jun: 'June',
    Jul: 'July',
    Aug: 'August',
    Sep: 'September',
    Oct: 'October',
    Nov: 'November',
    Dec: 'December',
  };

  // Check if the abbreviated month exists in the mappings

  if (Object.prototype.hasOwnProperty.call(monthMappings, abbreviatedMonth)) {
    return monthMappings[abbreviatedMonth];
  } else {
    // Return the input as is if no mapping is found
    return abbreviatedMonth;
  }
};

export const periodMap = {
  Jul: 'P1',
  Aug: 'P2',
  Sep: 'P3',
  Oct: 'P4',
  Nov: 'P5',
  Dec: 'P6',
  Jan: 'P7',
  Feb: 'P8',
  Mar: 'P9',
  Apr: 'P10',
  May: 'P11',
  Jun: 'P12',
};

export const getPeriodForMonth = month => {
  return periodMap[month];
};

export const formatDateToYYYYMMDD = dateStr => {
  const [month, day, year] = dateStr.split('/').map(Number);
  if (!isNaN(month) && !isNaN(day) && !isNaN(year)) {
    const date = new Date(year, month - 1, day);
    return date.toISOString().split('T')[0];
  }
  return dateStr;
};

export const convertDateToTimeStamp = inputDate => {
  if (inputDate) {
    const date = inputDate;
    const parts = date.split('/');
    var day = parts[1];
    var month = parts[0];
    var year = parts[2];
    var zero = parts[1] < 10 ? '0' : '';
    var timeStamp = `${year}-${month}-${zero}${day}T00:00:00.000Z`;
    return timeStamp;
  }
};

export const convertDateToTimeStamp2 = inputDate => {
  if (inputDate) {
    const date = inputDate;
    const parts = date.split('-');
    var day = parts[2];
    var month = parts[1];
    var year = parts[0];
    var zero = parts[2] < 10 ? '0' : '';
    var timeStamp = `${year}-${month}-${zero}${day}T00:00:00.000Z`;
    return timeStamp;
  }
};

export const getFixed2DegitAfterDecimal = number => {
  if (typeof number !== 'number') {
    return 'TBD';
  }
  return number.toFixed(2);
};

export const getFormattedDate = inputDateStr => {
  // Wed May 01 2024 00:00:00 GMT+0530 to 2024-05-01
  var currentDate = new Date(inputDateStr);
  currentDate.setDate(currentDate.getDate());
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  var day = currentDate.getDate().toString().padStart(2, '0');

  var foramattedDate = `${year}-${month}-${day}`;
  return foramattedDate;
};

export const getFormattedDateAndTime = inputDateStr => {
  // "2024-03-19T15:50:10Z" to "Tue Mar 19 2024 15:50:10 GMT+0530 (India Standard Time)"
  var date = new Date(inputDateStr);

  var options = {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZoneName: 'short',
  };

  var foramattedDate = new Intl.DateTimeFormat('en-US', options).format(date);
  return foramattedDate;
};

export const getRemainingDays = (timestampString, systemDateTime) => {
  // Target Days
  let targetDate = new Date(timestampString);
  targetDate = new Date(targetDate.setHours(0, 0, 0, 0));

  // Current date
  let currentDate = new Date(systemDateTime);
  currentDate = new Date(currentDate.setHours(0, 0, 0, 0));

  // Calculate the time difference in milliseconds
  const timeDifference = targetDate - currentDate;
  let daysRemaining;

  // Calculate the number of days remaining
  if (timeDifference < 0) daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  else daysRemaining = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  // Format the target date as "YYYY-MM-DD"
  return daysRemaining;
};

export const trimAndAddDots = (inputString, stringLength = 23) => {
  // setting 23 default
  if (inputString === null || inputString === undefined || inputString === ' ') return 'NA';
  // Check if the string length is greater than 200
  if (inputString.length > stringLength) {
    // Trim the string to 200 characters and add three dots
    return `${inputString.slice(0, stringLength).trim()} ...`;
  } else {
    // Return the original string if its length is 200 or less
    return inputString;
  }
};

export const limitDecimalDigits = number => {
  if (number !== null && number !== undefined) {
    return Number(number.toFixed(2));
  } else {
    return 0;
  }
};

export const formateTOV = (number = 0) => {
  const InputValue = number === '-' || number === '-0' || number === 'TBD' ? 0 : number;
  // For addign '$' Sign to TOV value
  return Number(InputValue).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export const trimText = text => text.replace(/^Q\s*/i, '').trim();

export const getCurrentMonth = systemDateTime => {
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  return months[new Date(systemDateTime).getMonth()];
};

export const formatMinutes = minutes => {
  // 0  = 00
  // 4  = 04
  // 15 = 15
  if (minutes.length === 1) {
    return `0 ${minutes}`;
  } else {
    return minutes;
  }
};

export const getTime12Hr = dateObject => {
  // 2025-02-03T22:00:00.000Z to 03:30 AM
  const date = new Date(dateObject);
  const options = { hour12: true, hour: 'numeric', minute: 'numeric' };
  const time12hr = date.toLocaleTimeString('en-US', options);
  return time12hr;
};

export const processNumber = number => {
  if (number === 0 || number === null) return 0;

  if (number % 1 !== 0) {
    if (number - Math.floor(number) >= 0.5) {
      return Math.ceil(number);
    } else {
      return Math.floor(number);
    }
  } else {
    return number;
  }
};

export const RemoveTimeStamp = dateString => {
  const date = new Date(dateString);
  return date.toISOString().split('T')[0];
};

// inputeDate: "2025-02-06"
export const adjustOffsetToTimeZone = inputeDate => {
  const localDate = new Date(inputeDate); // IST
  const offsetMinutes = new Date().getTimezoneOffset(); // eslint-disable-line

  // Convert UTC time to milliseconds
  const utcMilliseconds = localDate.getTime();

  // Adjust the time by adding the offset (offset is in minutes)
  const adjustedTimeMilliseconds = utcMilliseconds + offsetMinutes * 60 * 1000; // eslint-disable-line

  // Create a new Date object with the adjusted time
  return new Date(adjustedTimeMilliseconds);
};

export const generateLoadingData = tableLoadingData => {
  return Array.from({ length: tableLoadingData.iterationCount }, () => ({
    ...tableLoadingData.data,
  }));
};

export const hasSystemTimePassed = targetDateTime => {
  let systemDateTime;
  if (localStorage.getItem('modifiedSystemDateAndTime')) {
    systemDateTime = new Date(localStorage.getItem('modifiedSystemDateAndTime'));
  } else {
    systemDateTime = new Date();
  }
  return systemDateTime > targetDateTime;
};

export const formatTime = time => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes} mins ${seconds.toString().padStart(2, '0')} seconds`;
};

export const formatVarianceWithKAndM = number => {
  if (typeof number !== 'number') {
    return '0 K';
  }
  const absNumber = Math.abs(number);
  let formatted;
  if (absNumber >= 1000000000) {
    formatted =
      absNumber % 1000000000 === 0
        ? `${absNumber / 1000000000} B`
        : `${(absNumber / 1000000000).toFixed(1)} B`;
  } else if (absNumber >= 1000000) {
    formatted =
      absNumber % 1000000 === 0
        ? `${absNumber / 1000000} M`
        : `${(absNumber / 1000000).toFixed(1)} M`;
  } else if (absNumber >= 1000) {
    formatted =
      absNumber % 1000 === 0 ? `${absNumber / 1000} K` : `${(absNumber / 1000).toFixed(1)} K`;
  } else {
    formatted = absNumber.toString();
  }
  if (number < 0) {
    return `-${formatted}`;
  } else if (formatted === '0') {
    return '0 K';
  } else return formatted;
};
